import confetti from 'canvas-confetti';

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

window.confetti = async () => {
  confetti()
  await sleep(500)
  window.location.assign('/app');
}
